/**
 * Проверка страницы корзины
 * @param { VueRouter } router
 * @returns { boolean }
 */
const checkOrderPage = (router) => {
    return (
        router.history.current.name === "Order" ||
        router.history.current.name.startsWith("TheCheckout")
    );
};

const checkModalQuery = (route, popup) => {
    if (route.query.modal === "status-order") {
        popup.show("modal-status-order");
    }

    if (route.query.modal === "feedback-form") {
        popup.show("modal-feedback-footer");
    }
};

const checkQuery = (route, query) => {
    return route.query[query] && route.query[query].length > 0;
};

export { checkOrderPage, checkModalQuery, checkQuery };
